import type { ReactElement } from 'react'

/**
 * UpsellBanner star — Figma-exported `star` (node 6811:14328), fixed
 * orange `#EA4A27` in both themes (the iOS asset has identical light /
 * dark branches). Verbatim path; 26×26 viewBox.
 */
export function StarIcon({ size = 26 }: { size?: number }): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      aria-hidden="true"
      focusable="false"
      data-testid="rd-star-icon"
    >
      <path
        d="M11.763 3.8052C12.153 2.6079 13.8469 2.6079 14.2356 3.8052L15.6266 8.0848C15.7116 8.34544 15.8768 8.57253 16.0986 8.73364C16.3204 8.89474 16.5875 8.9816 16.8616 8.9818H21.3622C22.6219 8.9818 23.1445 10.5938 22.1266 11.3348L18.4866 13.979C18.2644 14.1402 18.0989 14.3677 18.0139 14.6288C17.9289 14.8899 17.9287 15.1712 18.0134 15.4324L19.4044 19.712C19.7944 20.9093 18.4229 21.9064 17.4024 21.1654L13.7624 18.5212C13.5404 18.36 13.2731 18.2732 12.9987 18.2732C12.7243 18.2732 12.457 18.36 12.2349 18.5212L8.59493 21.1654C7.57573 21.9064 6.20553 20.9093 6.59423 19.712L7.98523 15.4324C8.06996 15.1712 8.06981 14.8899 7.9848 14.6288C7.89979 14.3677 7.73429 14.1402 7.51203 13.979L3.87333 11.3361C2.85543 10.5951 3.37933 8.9831 4.63773 8.9831H9.13703C9.41139 8.98317 9.67874 8.89644 9.90081 8.73532C10.1229 8.5742 10.2883 8.34695 10.3733 8.0861L11.7643 3.8065L11.763 3.8052Z"
        fill="#EA4A27"
      />
    </svg>
  )
}
